<template>
  <div class="" style="overflow: auto;" >
    <b-row class="m-0 pt-4 mt-2 px-5 justify-content-between">
      <b-img  @click="$router.push('/restaurants').catch(err => {})" :src="require(`@/assets/logos/eatDoradoText.png`)" style="max-height: 50px; cursor: pointer; z-index: 1000" fluid alt="eatDorado Logo"></b-img>  
    </b-row>

    <b-row class="m-0 justify-content-center" v-if="order">
      <div style="width: 1600px; max-width: 100%">
        <b-row class="m-0 justify-content-center">
          <b-col cols="8" class="" style="z-index: 1000 !important">

        <div  class="showcase-invert bg-white shadow mx-2 mb-2 mt-5"  style="min-width: 95%" >
          <div class="showcase-header py-4 linear-primary text-white" style="position: relative; cursor: pointer" @click="$router.push('/orders').catch(err => {})">
            <h4 class="text-center m-0">Bestellung vom: {{ order.created | moment('DD.MM.YYYY HH:mm')}}</h4>
          </div>

            <div v-if="order">
              <b-row class="m-0 my-2 justify-content-between">
                <h5 class="m-0">Bestellnummer:</h5>
                <h5 class="m-0">{{order.ordernumber}}</h5>
              </b-row>
               <b-row class="m-0 my-2 justify-content-between">
                <h5 class="m-0">Abholzeit:</h5>
                <h5 class="m-0">{{order.delivery_time | moment('DD.MM.YYYY HH:mm')}}</h5>
              </b-row>
              <b-row class="m-0 my-2 mb-4 justify-content-between">
                <h5 class="m-0">Besteller:</h5>
                <h5 class="m-0">{{order.customer_firstname}} {{order.customer_lastname}}</h5>
              </b-row>
              <div>
                <div v-for="item in order.items" :key="item.index">
                  <b-row class="m-0 justify-content-between">
                    <h5 class="m-0">{{ item._id.title }}</h5>
                    <h5 class="m-0">x {{ item.amount }}</h5>
                  </b-row>
                  <b-row class="m-0 justify-content-between" v-if="item.note">
                    <p class="m-0">Hinweis: {{ item.note }}</p>
                  </b-row>
                  <hr class="my-2">
                </div>
              </div>
              
              <b-row class="m-0 mt-3 justify-content-between">
                <h5 class="m-0">Rechnungsbetrag:</h5>
              <h5 class="m-0">{{getTotalPrice(order)}}</h5>
              </b-row>
              <b-row class="m-0 mt-3 justify-content-between">
                <b-button block variant="warning" v-if="order.status == 'bestellt'" @click="updateOrder('bestätigt')">Bestellung bestätigen</b-button>
                <b-button block variant="info" v-if="order.status == 'bestätigt'" @click="updateOrder('bereit')">Bestellung ist abholbereit</b-button>
                <b-button block variant="success" v-if="order.status == 'bereit'" @click="updateOrder('abgeholt')">Bestellung wurde abgeholt</b-button>
                <b-button block variant="success" disabled v-if="order.status == 'abgeholt'" >Bestellung ist abgeschlossen!</b-button>
              </b-row>
            </div>

        </div>
        

            <!-- <div class="mt-3 mt-lg-4 shadow bg-white rounded p-3">
              <h3 class="text-center mb-5">Bestellung:</h3>
              <div class="mx-2">
                <div class="my-3" v-for="(item) in order.items" :key="item.index">
                  <b-row class="m-0 p-0 justify-content-between" >
                    <p class="m-0" :key="item.amount">{{ item.amount }} x 
                    </p>
                    <p class="m-0">{{ item._id.title }}</p>
                    <p class="m-0">{{ item._id.price.toFixed(2) }}€</p>
                  </b-row>

                    <b-form-textarea
                      class="mt-2"
                      v-if="item._id.note"
                      disabled
                      id="textarea"
                      v-model="item._id.note"
                      placeholder="Hinweis für das Restaurant. z.B: Ohne Zwiebeln, mit Käse..."
                      rows="2"
                      max-rows="6"
                    ></b-form-textarea>

                </div>
                
                <hr class="m-2">

                <b-row class="m-0 justify-content-between w-100">
                  <h3>Gesamtpreis:</h3>
                  <h3>{{ totalPrice }}€</h3>
                </b-row>
              </div>
              <h3 class="text-center my-3">Bestellstatus</h3>
              <form-wizard
                :key="$route.params.id"
                title=""
                subtitle=""
                back-button-text="zurück"
                next-button-text="weiter"
                finish-button-text="Fertigstellen"
                color="rgba(255,193,7,1)"
                :startIndex="tab"
              >
                  <wizard-step 
                      slot-scope="props"
                      slot="step"
                      :tab="props.tab"
                      :transition="props.transition"
                      :index="props.index">
                  </wizard-step>

                  <tab-content title="Bestellung aufgegeben"
                                icon="ti-shopping-cart"
                                :before-change="validateAsyncStep1"
                                >

                    <p class="mt-5 text-center">Der Kunde hat die Bestellung aufgegeben und {{order.customer_verified ? 'hast sie bestätigt.' : 'muss sie noch bestätigen.'}} </p>                  
                    
                    
                  </tab-content>

                  <tab-content title="Bestellung bestätigt"
                                icon="ti-check"
                                
                                >
                    <p class="mt-5 text-center">Die Bestellung wurde vom Kunden bestätigt. </p> 
                  </tab-content>

                  <tab-content title="Bestellung abholbereit"
                                icon="ti-car">
                                <b-row class="m-0 justify-content-center">
                                  <b-button variant="warning" @click="updateOrder()">Bestellung abschließen</b-button>
                                </b-row>
                                
                  </tab-content>
              </form-wizard>
              
            </div> -->
          </b-col>      
        </b-row>
      </div>
    </b-row>

    <b-row class="m-0 justify-content-center" v-if="!order && !updating">
      <div style="width: 1600px; max-width: 100%">
        <b-row class="m-0 justify-content-center">
          <b-col cols="12" lg="12" style="z-index: 1000 !important">
            <div class="mt-3 shadow bg-white rounded p-3">
              <b-row class="m-0 my-5 justify-content-center">
                <b-img :src="require(`@/assets/images/undraw_searching.svg`)" style="height: 150px" fluid alt="eatDorado Logo"></b-img>  
              </b-row>
              <h3 class="text-center my-2">Diese Bestellung gibt es scheinbar nicht...</h3>
              <div style="height: 60vh; max-height: 60vh; overflow-y: auto; z-index: 1000 !important" class="pt-2">

              </div>
            </div>
          </b-col>      
        </b-row>
      </div>
    </b-row>

    <!-- <div style="height: 60vh; max-height: 60vh; overflow-y: auto; z-index: 1000 !important" class="pt-2" v-if="updating">
      <loading-overlay :text="'lade Restaurant...'" />
    </div> -->
    
    <Footer class="my-5"></Footer>

  </div>
</template>

<script>

import Footer from '@/components/Footer'
// import LoadingOverlay from '../shared/animations/loadingOverlay.vue'
import coreData from '@/mixins/coreDataMixin'

export default {
  name: 'Order',
  mixins: [coreData],
  components: {
    Footer,
    // LoadingOverlay,
  },
  data: () => {
    return {
      securityCode: '',
    }
  },
  props: {
    startIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    totalPrice(){
      var total = 0.00
      if(this.order.items.length == 0) return total

      this.order.items.forEach(item => {
        total += item._id.price * item.amount
      })

      return total.toFixed(2)
    },
    tab(){
      if(this.order.status == 'completed') return 2
      if(this.order.customer_verified === true) return 1
      return 0
    },
    updating(){
      return this.$store.getters.updating
    },
    orderState(){
      return this.$store.getters.orderState
    },
    loggedIn(){
      return this.$store.getters.loggedIn
    },
    order(){
      return this.$store.getters.order
    }
  },
  watch: {
  
  },
  mounted(){
    this.$store.dispatch('getOrder', {_id: this.$route.params.id})
  },
  methods: {
    updateOrder(status){
      const payload = {
        _id: this.$route.params.id,
        data: {
          status: status
        }
      }

      this.$store.dispatch('updateOrder', payload)
    },
    // confirmOrder(){
    //   if(this.order.customer_verified) return
    //   const payload = {
    //     _id: this.order._id,
    //     data: {
    //       verification_number: this.securityCode
    //     }
    //   }

    //   this.$store.dispatch('confirmOrder', payload)
    //   this.$store.dispatch('getOrder', {_id: this.$route.params.id})
    //   this.$store.dispatch('getOrders')
    // },
    resendCode(){
      this.$store.dispatch('resendConfirmation', {_id: this.$route.params.id})
    },
    validateAsyncStep1:function() {
      return new Promise((resolve, reject) => {
        if(this.order.customer_verified) resolve(true)
        reject(false)
      })
    },
    validateAsyncStep2:function() {
      return new Promise((resolve, reject) => {
        if(this.order.status == 'completed') resolve(true)
        reject(false)
      })
    }
  }
}
</script>